import React from 'react';

interface EmptyStateProps {
    message: string;
    subMessage?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ message, subMessage }) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '48px 0',
            color: '#a09890'
        }}>
            <p style={{ fontSize: '14px', fontWeight: 500 }}>{message}</p>
            {subMessage && <p style={{ fontSize: '12px', marginTop: '4px' }}>{subMessage}</p>}
        </div>
    );
};